import BannerFormPage from "./BannerFormPage";

export default function BannerAdd() {
  return (
    <BannerFormPage
      mode="add"
      bannerType="main"
      pageTitle="Add Banner"
      breadcrumbTitle="Add Banner"
      backPath="/banner"
      successMessage="Banner added successfully"
    />
  );
}
